module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sendMoney/store-details/store-details.component.css
// module id = ./src/app/sendMoney/store-details/store-details.component.css
// module chunks = main